import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./DiscStyles";

export default class Disc extends Component {
  render() {
    return (
      <div
        className={css([
          styles.disc,
          styles[this.props.size],
          this.props.isSelectable && styles.discSelectable
        ])}
      >
        <div className={css([styles.innerDisc, styles[this.props.state]])} />
        <div className={css(styles.center)} />
        <img
          className={css(styles.icon, this.props.size === "noDisc" && styles.iconLarge)}
          src={this.props.icon}
          alt=""
        />
      </div>
    );
  }
}
